/**
 * Getters for search
 */
export const getters = {
  getSearchValue(state) {
    return state.searchValue;
  },
  getStartDate(state) {
    return state.startDate;
  },
  getEndDate(state) {
    return state.endDate;
  },
  getSearchResults(state) {
    return state.results;
  },
  getEmailSearchResults(state) {
    return state.emailResults;
  },
  getShowResultsNow(state) {
    return state.showResultsNow;
  },
  getSearching(state) {
    return state.searchingLoader;
  },
  getFiltertypeAll(state) {
    return state.filtertypeAll ;
  },
  getFiltertypeSubject(state) {
    return state.filtertypeSubject ;
  },
  getFiltertypeSender(state) {
    return state.filtertypeSender ;
  },
  getFiltertypeReceiver(state) {
    return state.filtertypeReceiver;
  }
};
